module.exports = __webpack_public_path__ + "img/select03.85a448b5.png";